export default __webpack_public_path__ + "static/media/money.ab83bef7.png";